var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{attrs:{"id":"app"}},[_c('comp-day-spark-line',{attrs:{"device_id":_vm.device_id,"target_date":_vm.target_date}})],1)
}
var staticRenderFns = []

export { render, staticRenderFns }